import { CommonModule, NgClass } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import {
  Icon,
  IconExclamationTriangle,
  IconInfoCircle,
  IconRegistryService,
  IconX,
} from "pax-ui/icons";

import { Markdown } from "../markdown";

@Component({
  selector: "pax-alert",
  imports: [CommonModule, Icon, Markdown],
  templateUrl: "./alert.html",
  styleUrls: ["./alert.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Alert {
  private readonly _icons = [IconInfoCircle, IconExclamationTriangle, IconX];

  constructor(iconRegistry: IconRegistryService) {
    iconRegistry.registerIcons(this._icons);
  }

  @Input()
  containerClass: NgClass["ngClass"] = "";

  @Input()
  title?: string;

  @Input()
  variant: "info" | "warning" | "error" = "info";

  @Input()
  markdown?: string;

  @Input()
  markdownAsData?: string;

  @Input()
  content?: string | undefined;

  @Input()
  showCloseButton = false;

  @Output()
  closeDialog = new EventEmitter<void>();
}
